import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';


@Component({
    selector: 'app-litmus-attatchment',
    templateUrl: './litmus-attatchment.component.html',
    styleUrls: ['./litmus-attatchment.component.scss'],
    standalone: false
})
export class LitmusAttatchmentComponent {
  @Input() name:string="files"
  @Input() multiple:boolean = false;
  @Input() accept:string= "";
  @Input() files:any;
  @Output() change:any = new EventEmitter<any>()
  constructor(){}
  onFileSelect(event:any){ 
    event.stopPropagation();
    this.files = event.target.files
    
    this.change.emit({files:event.target.files})
    event.target.value ='';
  }

}
